import { render, staticRenderFns } from "./keywordPlanning.vue?vue&type=template&id=6058e552&scoped=true"
import script from "./keywordPlanning.vue?vue&type=script&lang=js"
export * from "./keywordPlanning.vue?vue&type=script&lang=js"
import style0 from "./keywordPlanning.vue?vue&type=style&index=0&id=6058e552&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058e552",
  null
  
)

export default component.exports